(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-background-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-video-background')) {
    class TdVideoBackground extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('[data-td-video-element]');
        if (!(video instanceof HTMLVideoElement)) return;

        const sources = this.querySelectorAll('source[data-td-video-source]');

        sources.forEach((source) => {
          if (!(source instanceof HTMLSourceElement)) return;
          const sourceUrl = source.dataset.tdVideoSource;
          if (!sourceUrl) return;
          if (source.getAttribute('src') !== sourceUrl) {
            source.setAttribute('src', sourceUrl);
          }
        });

        video.load();
      }
    }

    customElements.define('td-video-background', TdVideoBackground);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-bogos-drawer-bridge"] && !Shopify.designMode) return;
  try {
    (() => {
    const EVENT_NAMES = {
      cartUpdate: 'cart:update',
      renderCartMessage: 'fg-messages:render',
    };
    const SELECTORS = {
      message: '[data-td-bogos-message]',
      messageContent: '[data-td-bogos-message-content]',
      defaultMessage: '.sca-promotion-message-layout .content-promotion-message',
    };
    const STATE_KEY = '__tdBogosDrawerBridgeState';
    const SYNC_ATTEMPTS = 6;
    const SYNC_INTERVAL_MS = 250;

    function getState() {
      if (!window[STATE_KEY]) {
        window[STATE_KEY] = {
          messages: [],
        };
      }

      return window[STATE_KEY];
    }

    function normalizeMessages(detail) {
      const data = Array.isArray(detail?.data) ? detail.data : [];

      return data
        .map((item) => ({
          value: typeof item?.offer === 'string' ? item.offer.trim() : '',
        }))
        .filter((item) => item.value !== '');
    }

    class TDBogosDrawerBridge extends HTMLElement {
      connectedCallback() {
        this.message = this.querySelector(SELECTORS.message);
        this.messageContent = this.querySelector(SELECTORS.messageContent);
        this.messageMarkup = null;
        this.pendingSyncTimer = null;
        this.pendingSyncFrame = null;

        document.addEventListener(EVENT_NAMES.cartUpdate, this.handleCartUpdate);
        document.addEventListener(EVENT_NAMES.renderCartMessage, this.handleCartMessage);

        this.syncFromDefaultMessage();
        this.render(getState());
        this.scheduleCartSync();
      }

      disconnectedCallback() {
        document.removeEventListener(EVENT_NAMES.cartUpdate, this.handleCartUpdate);
        document.removeEventListener(EVENT_NAMES.renderCartMessage, this.handleCartMessage);
        this.clearPendingSync();
      }

      handleCartMessage = (event) => {
        this.clearPendingSync();
        const state = getState();
        state.messages = normalizeMessages(event.detail);
        this.render(state);
      };

      handleCartUpdate = () => {
        this.scheduleCartSync();
      };

      clearPendingSync() {
        if (typeof this.pendingSyncFrame === 'number') {
          window.cancelAnimationFrame(this.pendingSyncFrame);
          this.pendingSyncFrame = null;
        }

        if (typeof this.pendingSyncTimer === 'number') {
          window.clearTimeout(this.pendingSyncTimer);
          this.pendingSyncTimer = null;
        }
      }

      scheduleCartSync(attempt = 0) {
        this.clearPendingSync();

        this.pendingSyncFrame = window.requestAnimationFrame(() => {
          this.pendingSyncFrame = null;

          if (this.syncFromDefaultMessage()) {
            this.render(getState());
            return;
          }

          if (attempt >= SYNC_ATTEMPTS - 1) {
            const state = getState();
            state.messages = [];
            this.render(state);
            return;
          }

          this.pendingSyncTimer = window.setTimeout(() => {
            this.pendingSyncTimer = null;
            this.scheduleCartSync(attempt + 1);
          }, SYNC_INTERVAL_MS);
        });
      }

      syncFromDefaultMessage() {
        const defaultMessages = Array.from(document.querySelectorAll(SELECTORS.defaultMessage))
          .map((message) => ({
            value: message.innerHTML.trim(),
          }))
          .filter((message) => message.value !== '');

        if (defaultMessages.length === 0) {
          return false;
        }

        const state = getState();
        state.messages = defaultMessages;
        return true;
      }

      render(state) {
        const hasMessages = Array.isArray(state.messages) && state.messages.length > 0;

        if (this.message instanceof HTMLElement) {
          this.message.hidden = !hasMessages;
        }

        if (this.messageContent instanceof HTMLElement) {
          const messageMarkup = hasMessages
            ? state.messages.map((message) => `<div class="td-bogos-drawer-bridge__message-item">${message.value}</div>`).join('')
            : '';

          if (messageMarkup !== this.messageMarkup) {
            this.messageContent.innerHTML = messageMarkup;
            this.messageMarkup = messageMarkup;
          }
        }

        this.hidden = !hasMessages;
      }
    }

    if (!customElements.get('td-bogos-drawer-bridge')) {
      customElements.define('td-bogos-drawer-bridge', TDBogosDrawerBridge);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-review"] && !Shopify.designMode) return;
  try {
    (function() {
    const ratingWrappers = document.querySelectorAll('[data-scroll-to-reviews="true"]');
    if (ratingWrappers.length === 0) return;

    const scrollToReviews = (e) => {
      if (e.type === 'keydown' && !['Enter', ' '].includes(e.key)) return;
      e.preventDefault();

      const target = document.querySelector('#judgeme_product_reviews');
      if (!target) return;

      const header = document.querySelector('header-component, header, .section-header');
      const offset = header?.offsetHeight || 0;
      const topPosition = target.getBoundingClientRect().top + window.scrollY - offset;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: topPosition,
        behavior: reduceMotion ? 'instant' : 'smooth'
      });

      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    };

    for (const ratingWrapper of ratingWrappers) {
      if (ratingWrapper.dataset.tdReviewInitialized === 'true') continue;

      ratingWrapper.dataset.tdReviewInitialized = 'true';
      ratingWrapper.addEventListener('click', scrollToReviews);
      ratingWrapper.addEventListener('keydown', scrollToReviews);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-video"] && !Shopify.designMode) return;
  try {
    (() => {
    const TD_VIDEO_DESKTOP_MIN_WIDTH = 1024;
    const TD_VIDEO_AUTOPLAY_DELAY_MS = 100;

    /**
     * @param {HTMLIFrameElement} iframe
     * @param {string} payload
     */
    function tdVideoPostToIframe(iframe, payload) {
      iframe.contentWindow?.postMessage(payload, '*');
    }

    /**
     * @param {string} ratioValue
     * @returns {number | null}
     */
    function tdVideoParseAspectRatio(ratioValue) {
      if (typeof ratioValue !== 'string') return null;

      const normalized = ratioValue.trim();
      if (!normalized) return null;

      if (normalized.includes('/')) {
        const ratioParts = normalized.split('/');
        if (ratioParts.length !== 2) return null;

        const width = Number.parseFloat(ratioParts[0].trim());
        const height = Number.parseFloat(ratioParts[1].trim());
        if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;

        return width / height;
      }

      const ratio = Number.parseFloat(normalized);
      if (!Number.isFinite(ratio) || ratio <= 0) return null;

      return ratio;
    }

    /**
     * @param {HTMLElement} element
     * @param {number} width
     * @returns {number}
     */
    function tdVideoResolveMinHeightFromRatio(element, width) {
      if (!(element instanceof HTMLElement) || width <= 0) return 0;

      const ratio = tdVideoParseAspectRatio(getComputedStyle(element).getPropertyValue('--td-media-aspect-ratio'));
      if (!ratio) return 0;

      return width / ratio;
    }

    if (!customElements.get('td-deferred-media')) {
      class TdDeferredMedia extends HTMLElement {
        constructor() {
          super();
          this.isPlaying = false;
          this.handleShow = this.showDeferredMedia.bind(this);
          this.handleToggle = this.toggleMedia.bind(this);
          this.handleMediaStarted = this.onMediaStarted.bind(this);
        }

        connectedCallback() {
          this.showButton = this.querySelector('[data-td-video-action="show"]');
          this.toggleButton = this.querySelector('[data-td-video-action="toggle"]');

          this.showButton?.addEventListener('click', this.handleShow);
          this.toggleButton?.addEventListener('click', this.handleToggle);
          document.addEventListener('td:media-started-playing', this.handleMediaStarted);

          const shouldAutoLoad = this.hasAttribute('autoplay') || !(this.showButton instanceof HTMLButtonElement);
          if (shouldAutoLoad) {
            this.loadContent(false);
            this.isPlaying = true;
            this.updatePlayPauseHint(this.isPlaying);
          }
        }

        disconnectedCallback() {
          this.showButton?.removeEventListener('click', this.handleShow);
          this.toggleButton?.removeEventListener('click', this.handleToggle);
          document.removeEventListener('td:media-started-playing', this.handleMediaStarted);
        }

        /**
         * @param {Event} event
         */
        onMediaStarted(event) {
          if (!(event instanceof CustomEvent)) return;
          if (event.detail?.resource === this) return;
          if (this.hasAttribute('autoplay')) return;
          if (event.detail?.isAutoplay) return;
          this.pauseMedia();
        }

        /**
         * @param {boolean} isPlaying
         */
        updatePlayPauseHint(isPlaying) {
          if (!(this.toggleButton instanceof HTMLElement)) return;

          this.toggleButton.classList.remove('hidden');
          const playIcon = this.toggleButton.querySelector('.icon-play');
          if (playIcon) playIcon.classList.toggle('hidden', isPlaying);
          const pauseIcon = this.toggleButton.querySelector('.icon-pause');
          if (pauseIcon) pauseIcon.classList.toggle('hidden', !isPlaying);
        }

        showDeferredMedia() {
          this.loadContent(true);
          this.isPlaying = true;
          this.updatePlayPauseHint(this.isPlaying);
        }

        /**
         * @param {boolean} [focus]
         */
        loadContent(focus = true) {
          if (this.hasAttribute('data-media-loaded')) return;

          const existingMedia = this.querySelector('video, iframe[data-video-type]');
          if (existingMedia instanceof Element) {
            document.dispatchEvent(
              new CustomEvent('td:media-started-playing', {
                detail: {
                  resource: this,
                  isAutoplay: this.hasAttribute('autoplay'),
                },
              })
            );

            this.setAttribute('data-media-loaded', 'true');
            this.showButton?.classList.add('deferred-media__playing');

            if (focus && existingMedia instanceof HTMLElement) {
              existingMedia.focus();
            }

            return;
          }

          document.dispatchEvent(
            new CustomEvent('td:media-started-playing', {
              detail: {
                resource: this,
                isAutoplay: this.hasAttribute('autoplay'),
              },
            })
          );

          const content = this.querySelector('template')?.content.firstElementChild?.cloneNode(true);
          if (!(content instanceof Element)) return;

          this.setAttribute('data-media-loaded', 'true');
          this.appendChild(content);

          if (focus && content instanceof HTMLElement) {
            content.focus();
          }

          this.showButton?.classList.add('deferred-media__playing');

          if (content instanceof HTMLVideoElement && content.hasAttribute('autoplay')) {
            content.play().catch(() => {});
          }
        }

        toggleMedia() {
          if (this.isPlaying) {
            this.pauseMedia();
          } else {
            this.playMedia();
          }
        }

        playMedia() {
          const iframe = this.querySelector('iframe[data-video-type]');
          if (iframe instanceof HTMLIFrameElement) {
            if (iframe.dataset.videoType === 'youtube') {
              tdVideoPostToIframe(iframe, '{"event":"command","func":"playVideo","args":""}');
            } else {
              tdVideoPostToIframe(iframe, '{"method":"play"}');
            }
          } else {
            const video = this.querySelector('video');
            if (video instanceof HTMLVideoElement) {
              video.play().catch(() => {});
            }
          }

          this.isPlaying = true;
          this.updatePlayPauseHint(this.isPlaying);
        }

        pauseMedia() {
          const iframe = this.querySelector('iframe[data-video-type]');
          if (iframe instanceof HTMLIFrameElement) {
            if (iframe.dataset.videoType === 'youtube') {
              tdVideoPostToIframe(iframe, '{"event":"command","func":"pauseVideo","args":""}');
            } else {
              tdVideoPostToIframe(iframe, '{"method":"pause"}');
            }
          } else {
            const video = this.querySelector('video');
            if (video instanceof HTMLVideoElement) {
              video.pause();
            }
          }

          this.isPlaying = false;

          if (this.hasAttribute('data-media-loaded')) {
            this.updatePlayPauseHint(this.isPlaying);
          }
        }
      }

      customElements.define('td-deferred-media', TdDeferredMedia);
    }

    if (!customElements.get('td-video-dialog')) {
      class TdVideoDialog extends HTMLElement {
        constructor() {
          super();
          this.autoplayTimer = null;
          this.autoplayObserver = null;
          this.handleOpen = this.onOpenClick.bind(this);
          this.handleClose = this.onCloseClick.bind(this);
          this.handleDialogCancel = this.onDialogCancel.bind(this);
          this.handleDialogClick = this.onDialogClick.bind(this);
        }

        prefersReducedMotion() {
          return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        shouldPlayInlineForViewport() {
          const isDesktop = window.innerWidth >= TD_VIDEO_DESKTOP_MIN_WIDTH;
          return (isDesktop && this.getAttribute('data-modal-desktop') !== 'true')
            || (!isDesktop && this.getAttribute('data-modal-mobile') !== 'true');
        }

        setupAutoplayObserver() {
          if (this.getAttribute('data-autoplay-inline') !== 'true') return;
          if (this.prefersReducedMotion()) return;
          if (!this.shouldPlayInlineForViewport()) return;

          this.autoplayObserver = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              if (!entry?.isIntersecting) return;

              this.autoplayObserver?.disconnect();
              this.autoplayObserver = null;
              this.playInline();
            },
            { rootMargin: '50px', threshold: 0 }
          );
          this.autoplayObserver.observe(this);
        }

        connectedCallback() {
          this.style.display = 'block';

          this.opener = this.querySelector('[data-td-video-opener]');
          this.openButton = this.querySelector('[data-td-video-action="open"]');
          this.closeButtons = this.querySelectorAll('[data-td-video-action="close"]');
          this.dialog = this.querySelector('[data-td-video-dialog]');

          this.openButton?.addEventListener('click', this.handleOpen);
          this.closeButtons.forEach((button) => button.addEventListener('click', this.handleClose));

          if (this.dialog instanceof HTMLDialogElement) {
            this.dialog.addEventListener('cancel', this.handleDialogCancel);
            this.dialog.addEventListener('click', this.handleDialogClick);
          }

          this.setExpanded(false);
          this.setupAutoplayObserver();
        }

        disconnectedCallback() {
          this.openButton?.removeEventListener('click', this.handleOpen);
          this.closeButtons?.forEach((button) => button.removeEventListener('click', this.handleClose));

          if (this.dialog instanceof HTMLDialogElement) {
            this.dialog.removeEventListener('cancel', this.handleDialogCancel);
            this.dialog.removeEventListener('click', this.handleDialogClick);
          }

          this.clearAutoplayTimer();
          this.autoplayObserver?.disconnect();
          this.autoplayObserver = null;
          this.resetInlinePlayer();
        }

        onOpenClick(event) {
          event.preventDefault();
          this.open();
        }

        onCloseClick(event) {
          event.preventDefault();
          this.close();
        }

        onDialogCancel(event) {
          event.preventDefault();
          this.close();
        }

        onDialogClick(event) {
          if (event.target === this.dialog) this.close();
        }

        setExpanded(isExpanded) {
          if (this.openButton instanceof HTMLElement) {
            this.openButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
          }
        }

        open() {
          const isDesktop = window.innerWidth >= TD_VIDEO_DESKTOP_MIN_WIDTH;
          const shouldOpenInModal =
            (isDesktop && this.getAttribute('data-modal-desktop') === 'true')
            || (!isDesktop && this.getAttribute('data-modal-mobile') === 'true');

          if (shouldOpenInModal) {
            if (this.dialog instanceof HTMLDialogElement) {
              if (!this.dialog.open) this.dialog.showModal();
            } else if (this.dialog instanceof HTMLElement) {
              this.dialog.setAttribute('open', '');
            }

            this.setExpanded(true);
            this.autoplay();
          } else {
            this.playInline();
          }
        }

        close() {
          this.clearAutoplayTimer();
          this.pauseAndReset();

          if (this.dialog instanceof HTMLDialogElement) {
            if (this.dialog.open) this.dialog.close();
          } else if (this.dialog instanceof HTMLElement) {
            this.dialog.removeAttribute('open');
          }

          this.setExpanded(false);
        }

        getDialogMedia() {
          const media = this.dialog?.querySelector('td-deferred-media');
          return media instanceof HTMLElement ? media : null;
        }

        /**
         * @param {Element | null} media
         * @param {boolean} [focus]
         */
        ensureDeferredMediaLoaded(media, focus = false) {
          if (!(media instanceof HTMLElement)) return null;

          if (media.hasAttribute('data-media-loaded')) return media;

          if (typeof media.loadContent === 'function') {
            media.loadContent(focus);
            return media;
          }

          const content = media.querySelector('template')?.content.firstElementChild?.cloneNode(true);
          if (content instanceof Element) {
            media.setAttribute('data-media-loaded', 'true');
            media.appendChild(content);

            if (focus && content instanceof HTMLElement) {
              content.focus();
            }

            const showButton = media.querySelector('[data-td-video-action="show"]');
            if (showButton instanceof HTMLElement) {
              showButton.classList.add('deferred-media__playing');
            }

            return media;
          }

          const existingMedia = media.querySelector('video, iframe[data-video-type]');
          if (existingMedia instanceof Element) {
            media.setAttribute('data-media-loaded', 'true');
            return media;
          }

          return null;
        }

        /**
         * @param {Element | null} media
         */
        unloadDeferredMedia(media) {
          if (!(media instanceof HTMLElement)) return;

          const showButton = media.querySelector('[data-td-video-action="show"]');
          media.querySelectorAll('video, iframe[data-video-type]').forEach((el) => el.remove());
          media.removeAttribute('data-media-loaded');

          if (showButton instanceof HTMLElement) {
            showButton.classList.remove('deferred-media__playing');
          }
        }

        autoplay() {
          const media = this.getDialogMedia();
          const loadedMedia = this.ensureDeferredMediaLoaded(media, false);
          if (!loadedMedia) return;
          this.clearAutoplayTimer();

          this.autoplayTimer = window.setTimeout(() => {
            const video = loadedMedia.querySelector('video');
            const iframe = loadedMedia.querySelector('iframe[data-video-type]');
            const keepMuted = loadedMedia.hasAttribute('autoplay');

            if (video instanceof HTMLVideoElement) {
              this.playHtmlVideo(video, keepMuted);
            } else if (iframe instanceof HTMLIFrameElement) {
              this.playIframe(iframe);
            }
          }, TD_VIDEO_AUTOPLAY_DELAY_MS);
        }

        clearAutoplayTimer() {
          if (this.autoplayTimer !== null) {
            window.clearTimeout(this.autoplayTimer);
            this.autoplayTimer = null;
          }
        }

        /**
         * @param {HTMLVideoElement} video
         */
        async playHtmlVideo(video, keepMuted = false) {
          if (!video.hasAttribute('playsinline')) {
            video.setAttribute('playsinline', '');
          }

          if (keepMuted) {
            video.muted = true;
          }

          try {
            await video.play();
            if (keepMuted) return;

            video.muted = false;
          } catch {
            video.muted = true;

            try {
              await video.play();
              if (!keepMuted) {
                setTimeout(() => {
                  video.muted = false;
                }, TD_VIDEO_AUTOPLAY_DELAY_MS);
              }
            } catch (error) {
              console.warn('TD video autoplay failed:', error);
            }
          }
        }

        /**
         * @param {HTMLIFrameElement} iframe
         */
        playIframe(iframe) {
          if (iframe.dataset.videoType === 'youtube') {
            tdVideoPostToIframe(iframe, '{"event":"command","func":"playVideo","args":""}');
            tdVideoPostToIframe(iframe, '{"event":"command","func":"unMute","args":""}');
          } else if (iframe.dataset.videoType === 'vimeo') {
            tdVideoPostToIframe(iframe, '{"method":"play"}');
            tdVideoPostToIframe(iframe, '{"method":"setVolume","value":1}');
          }
        }

        pauseAndReset() {
          const media = this.getDialogMedia();
          if (media && typeof media.pauseMedia === 'function') {
            media.pauseMedia();
          }

          const video = this.dialog?.querySelector('video');
          if (video instanceof HTMLVideoElement) {
            video.currentTime = 0;
          }

          const iframe = this.dialog?.querySelector('iframe[data-video-type]');
          if (iframe instanceof HTMLIFrameElement) {
            if (iframe.dataset.videoType === 'youtube') {
              tdVideoPostToIframe(iframe, '{"event":"command","func":"seekTo","args":[0,true]}');
            } else if (iframe.dataset.videoType === 'vimeo') {
              tdVideoPostToIframe(iframe, '{"method":"setCurrentTime","value":0}');
            }
          }

          this.unloadDeferredMedia(media);
        }

        resetInlinePlayer() {
          if (!(this.opener instanceof HTMLElement)) return;

          const inlinePlayer = this.opener.querySelector('.td-inline-video-player');
          if (inlinePlayer instanceof HTMLElement) inlinePlayer.remove();
          this.opener.classList.remove('td-video-thumbnail--playing');
          this.opener.style.width = '';
          this.opener.style.minHeight = '';
        }

        playInline() {
          if (!(this.opener instanceof HTMLElement)) return;

          const media = this.getDialogMedia();
          if (!media) return;

          if (this.opener.querySelector('.td-inline-video-player')) return;

          const { width, height } = this.opener.getBoundingClientRect();
          if (width > 0) {
            this.opener.style.width = `${width}px`;
          }

          let resolvedMinHeight = height;
          if (resolvedMinHeight <= 0 && width > 0) {
            resolvedMinHeight = tdVideoResolveMinHeightFromRatio(this.opener, width);
          }
          if (resolvedMinHeight > 0) {
            this.opener.style.minHeight = `${resolvedMinHeight}px`;
          }

          const clone = media.cloneNode(true);
          if (!(clone instanceof HTMLElement)) return;

          clone.classList.add('td-inline-video-player', 'td-border-style');
          this.opener.classList.add('td-video-thumbnail--playing');
          this.opener.appendChild(clone);
          this.setExpanded(true);

          this.clearAutoplayTimer();
          this.autoplayTimer = window.setTimeout(() => {
            const loadedClone = this.ensureDeferredMediaLoaded(clone, false);
            if (!loadedClone) return;

            const video = loadedClone.querySelector('video');
            const iframe = loadedClone.querySelector('iframe[data-video-type]');
            const keepMuted = loadedClone.hasAttribute('autoplay');

            if (video instanceof HTMLVideoElement) {
              this.playHtmlVideo(video, keepMuted);
              video.addEventListener(
                'ended',
                () => {
                  this.resetInlinePlayer();
                  this.setExpanded(false);
                },
                { once: true }
              );
            } else if (iframe instanceof HTMLIFrameElement) {
              this.playIframe(iframe);
            }
          }, TD_VIDEO_AUTOPLAY_DELAY_MS);
        }
      }

      customElements.define('td-video-dialog', TdVideoDialog);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
